module.exports = __webpack_public_path__ + "img/img_news_default@2x.0b47a6c8.png";